module.exports = __webpack_public_path__ + "img/121.c1457eae.jpg";